export const FareCalculator = (
  distance,
  time,
  rateDetails,
  instructionData,
  decimal,
  customerPricing = null,
  driverPricing = null
) => {
  // Apply customer-specific multipliers if available
  let adjustedRates = { ...rateDetails };

  if (customerPricing && customerPricing.enabled) {
    // Check if pricing is still valid (not expired)
    if (customerPricing.validUntil) {
      const expiryDate = new Date(customerPricing.validUntil);
      const currentDate = new Date();
      if (currentDate > expiryDate) {
        // Pricing has expired, use standard rates
        customerPricing = null;
      }
    }

    if (customerPricing) {
      // Get vehicle-specific pricing using the vehicle ID
      const vehicleId = rateDetails.id || rateDetails.value;
      const vehicleConfig = customerPricing.vehiclePricing?.[vehicleId];

      if (vehicleConfig && vehicleConfig.enabled) {
        // Apply custom rates for this vehicle
        adjustedRates.rate_per_unit_distance = vehicleConfig.ratePerKm;
        adjustedRates.rate_per_hour = vehicleConfig.ratePerKm; // Assuming same rate structure
        adjustedRates.base_fare = vehicleConfig.baseFare;
        adjustedRates.convenience_fees = vehicleConfig.convenienceFees;

        // Use vehicle-specific minimum fare
        adjustedRates.min_fare = vehicleConfig.minFare;

        // Override with global minimum fare if specified
        if (
          customerPricing.minFareOverride &&
          customerPricing.minFareOverride > 0
        ) {
          adjustedRates.min_fare = customerPricing.minFareOverride;
        }
      }
    }
  }

  // Apply driver-specific pricing (convenience fees only)
  if (driverPricing && driverPricing.enabled) {
    // Check if pricing is still valid (not expired)
    if (driverPricing.validUntil) {
      const expiryDate = new Date(driverPricing.validUntil);
      const currentDate = new Date();
      if (currentDate > expiryDate) {
        // Pricing has expired, use standard rates
        driverPricing = null;
      }
    }

    if (driverPricing) {
      // Get vehicle-specific pricing using the vehicle ID
      const vehicleId = rateDetails.id || rateDetails.value;
      const vehicleConfig = driverPricing.vehiclePricing?.[vehicleId];

      if (vehicleConfig && vehicleConfig.enabled) {
        // Driver can only control convenience fees and type
        adjustedRates.convenience_fees = vehicleConfig.convenienceFees;
        adjustedRates.convenience_fee_type =
          vehicleConfig.convenienceFeeType || 'percentage';
        adjustedRates.fleet_admin_fee = vehicleConfig.fleetAdminFee;

        // Driver cannot change base rates (rate per km, base fare, min fare)
        // These remain from customer pricing or standard rates
      }
    }
  }

  let baseCalculated =
    parseFloat(adjustedRates.rate_per_unit_distance) * parseFloat(distance) +
    parseFloat(adjustedRates.rate_per_hour) * (parseFloat(time) / 3600);
  if (adjustedRates.base_fare > 0) {
    baseCalculated = baseCalculated + parseFloat(adjustedRates.base_fare);
  }
  if (instructionData && instructionData.parcelTypeSelected) {
    baseCalculated = baseCalculated + instructionData.parcelTypeSelected.amount;
  }
  if (instructionData && instructionData.optionSelected) {
    baseCalculated = baseCalculated + instructionData.optionSelected.amount;
  }
  let total =
    baseCalculated > parseFloat(adjustedRates.min_fare)
      ? baseCalculated
      : parseFloat(adjustedRates.min_fare);
  let convenienceFee = 0;
  if (
    adjustedRates.convenience_fee_type &&
    adjustedRates.convenience_fee_type == 'flat'
  ) {
    convenienceFee = parseFloat(adjustedRates.convenience_fees);
  } else {
    convenienceFee = (total * parseFloat(adjustedRates.convenience_fees)) / 100;
  }
  let grand = total + convenienceFee;

  return {
    totalCost: parseFloat(total.toFixed(decimal)),
    grandTotal: parseFloat(grand.toFixed(decimal)),
    convenience_fees: parseFloat(convenienceFee.toFixed(decimal)),
    // Add pricing info for transparency
    customPricingApplied:
      customerPricing && customerPricing.enabled ? true : false,
    driverCustomPricingApplied:
      driverPricing && driverPricing.enabled ? true : false,
    originalRates:
      (customerPricing && customerPricing.enabled) ||
      (driverPricing && driverPricing.enabled)
        ? rateDetails
        : null,
  };
};
